import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  PaymentInstrument,
  PaymentInstrumentVariables,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<PaymentInstrumentVariables, null>) {
  const { variables } = params;

  const {
    locator,
    Id,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  const search = {
    Id,
    cid,
    uid,
  };

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/PaymentInstrument${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<PaymentInstrumentVariables, null>({
  schema,
  dataPath: 'user:customer:payment_instrument',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.StoreOrNetwork,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  keySelector: variables => variables.Id,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  PaymentInstrumentVariables,
  null,
  PaymentInstrument,
  PaymentInstrument,
  PaymentInstrument
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,

  keySelector: paymentInstrument => paymentInstrument.Id,
  processorFn: response => response,
});
